import styled from "styled-components";
import COLORS from "components/atoms/colors";

const Line = styled.span<{ background?: string }>`
  display: block;
  width: 100%;
  height: 1px;
  background: ${({ background }) => background || COLORS.black["40%"]};
`;

export default Line;
